import store from '@/store/index'
import AuthService from '@/services/auth/AuthService'

let authUser = JSON.parse(localStorage.getItem('authUser')) || ''
let guestUser = JSON.parse(localStorage.getItem('guestUser')) || ''
let lastUserType = localStorage.getItem('LAST_USER_TYPE')

export const authModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    authUser,
    env: 'local',
    guestUser,
    guestRes: '',
    tokenInvalid: false,
    failedRequests: [],
    session: {
      requestLogin: false,
      type: lastUserType,
    },
  },
  mutations: {
    LOGIN_USER(state, user) {
      state.authUser = user

      localStorage.setItem('LAST_USER_TYPE', user.guest ? 'guest' : 'common')
      if (localStorage.getItem('authUser')) localStorage.removeItem('authUser')
      localStorage.setItem('authUser', JSON.stringify(user))

      state.session.type = user.guest ? 'guest' : 'common'
    },
    LOGOUT_USER(state) {
      state.authUser = ''
      state.guestUser = ''
    },
    SET_ENVIROMENT(state, payload) {
      state.env = payload
    },
    SET_SESSION(state) {
      state.session.requestLogin = false
      state.session.type = localStorage.getItem('LAST_USER_TYPE')
    },
    SET_GUEST_USER(state, payload) {
      state.guestUser = payload
    },
    GUEST_AUTH_RES(state, payload) {
      state.guestRes = payload
    },
    REQUEST_RELOGIN(state, boolean) {
      state.session.requestLogin = boolean
    },
    UPDATE_AUTH_USER(state, payload) {
      state.authUser = payload
    },
    SET_TOKEN_INVALID(state, payload) {
      state.tokenInvalid = payload
    },
    ADD_FAILED_REQUESTS(state, payload) {
      state.failedRequests.push(payload)
    },
    CLEAR_FAILED_REQUESTS(state) {
      state.failedRequests = []
    },
  },
  actions: {
    async updateLoginInfo({ dispatch, state, commit }, user) {
      user.filial = store.state.systemModule.getCurrentSystem
        ? store.state.systemModule.getCurrentSystem.CODIGO
        : user.filial

      if (!user.guest) {
        // ira atualizar informação do usuario para o proximo login
        let lastUserFilial = localStorage.getItem('LAST_USER_FILIAL')
          ? JSON.parse(localStorage.getItem('LAST_USER_FILIAL'))
          : []

        if (lastUserFilial.length > 0)
          lastUserFilial.map((element) => {
            if (element.NOME == user.user && element.filial !== user.filial) {
              element.filial = user.filial
            }
            return element
          })
        else {
          lastUserFilial.push({
            user: user.NOME,
            filial: user.filial,
          })
        }
        localStorage.setItem('LAST_USER_FILIAL', JSON.stringify(lastUserFilial))
      }
      await dispatch('setTokenInvalid', false)
      await commit('SET_ENVIROMENT', user.env)
      await commit('LOGIN_USER', user)

      if (state.authUser) {
        if (store.state.systemModule.systemList.length <= 0)
          await store.dispatch('systemModule/getSystems')
        /*
         * recuperar a filial e suas flags
         * Usuário convidado não verifica flags no front
         */
        await store.dispatch('systemModule/getSystem', state.authUser.filial)
      }
    },
    async updateAuthUser({ commit }, payload) {
      commit('UPDATE_AUTH_USER', payload)
    },
    async checkAuthToken({ state }) {
      try {
        let service = state.authUser.guest
          ? new AuthService('guest')
          : new AuthService('common')
        let authUser = state.authUser
        let authUserResponse = await service.getAuthUser(authUser.access_token)
        return authUserResponse
      } catch (err) {
        // dispatch('logoutUser')
      }
    },
    async loginUser({ commit, dispatch }, user) {
      let service = new AuthService('common')
      let userLoginResponse = await service.loginUser(user)
      let authUserResponse = await service.getAuthUser(
        userLoginResponse.data.access_token
      )

      user = { ...userLoginResponse.data, ...authUserResponse.data.user }
      if (userLoginResponse) commit('SET_SESSION')
      await dispatch('updateLoginInfo', user)
      return userLoginResponse
    },
    async loginGuestUser({ commit, dispatch }, payload) {
      let service = new AuthService('guest')
      let guest = {
        email: payload.email,
        password: payload.token,
        doc: payload.doc,
      }

      let response = await service.loginUser(guest)

      if (response) {
        commit('LOGOUT_USER')
        commit('SET_SESSION')
      }

      let authenticate = await service.getAuthUser(response.data.access_token)

      let user = { ...response.data, ...authenticate.data.user }
      await dispatch('updateLoginInfo', user)

      return user
    },
    async logoutUser({ dispatch, state }, stack = 'all') {
      let response = ''
      try {
        if (stack === 'all') {
          let service = state.authUser.guest
            ? new AuthService('guest')
            : new AuthService('common')
          
          response = await service.logoutUser()
        }
      } finally {
        /**
         * se ocorrer o erro, limpa tudo para que o usuário tenha possibilidade de acessar em caso de
         * falha na rede ou troca de dominio
         **/
        await dispatch('clearAuthUser')
        await dispatch('setTokenInvalid', false)
      }
      return response
    },
    async clearAuthUser({ commit, dispatch }) {
      if (localStorage.getItem('authUser'))
        await localStorage.removeItem('authUser')

      // remover flags
      await dispatch('systemModule/setSystem', {}, { root: true })
      await commit('LOGOUT_USER')
      await commit('SET_SESSION')
    },
    async setTokenInvalid({ commit }, payload) {
      await commit('SET_TOKEN_INVALID', payload)
    },
    async addFailedRequests({ commit }, payload) {
      await commit('ADD_FAILED_REQUESTS', payload)
    },
    async clearFailedRequests({ commit }) {
      await commit('CLEAR_FAILED_REQUESTS')
    },
    async loadGuestUser({ commit, dispatch }, payload) {
      let guestUser = await dispatch('companyModule/getCompany', payload, {
        root: true,
      })
      guestUser = {
        ATIVO: guestUser.ativo,
        CGC: guestUser.cgc,
        CIDADE: { ...guestUser.cidade },
        CODIGO: guestUser.codigo,
        // BAIRRO: guestUser.bairro,
        // ENDERECO: guestUser.endereco,
        // FONE: guestUser.fone,
        // NUMERO: guestUser.numero,
        OBSBALCAO: guestUser.obsBalcao,
        PAIS: { ...guestUser.pais },
        RAMOATIVIDADE: { ...guestUser.ramoAtividade },
        RAZAOSOCIAL: guestUser.razaoSocial,
        NOME: guestUser.razaoSocial,
        TIPOEMPRESA: { ...guestUser.tipoEmpresa },
        TIPOVENDA: { ...guestUser.tipoVenda },
        UF: guestUser.uf,
      }

      if (localStorage.getItem('guestUser'))
        localStorage.removeItem('guestUser')
      localStorage.setItem('guestUser', JSON.stringify(guestUser))

      commit('SET_GUEST_USER', guestUser)
      return guestUser
    },
    async sendEmail({ commit }, payload) {
      let service = new AuthService('guest')
      let response = await service.getGuestAuthentication(payload)
      commit('GUEST_AUTH_RES', response)
      return response.data
    },
    async requestRelogin({ commit }, boolean) {
      commit('REQUEST_RELOGIN', boolean)
    },
  },
  getters: {
    getAuthUser: (state) => state.authUser,
    getGuestUser: (state) => state.guestUser,
    getSession: (state) => state.session,
  },
}
